import api from '../api';
import { queryToString } from 'helpers/AppHelpers';

export const getAssembliesApi = (query) =>
  api.get(`/ShortedAssembledItem?${queryToString(query)}`).then((res) => res.data);
